// Firebase is auto-initialized in React Native Firebase
// Make sure you have google-services.json (Android) and GoogleService-Info.plist (iOS) configured
// See: https://rnfirebase.io/

// Import Firebase modules - React Native Firebase uses default exports
import auth from '@react-native-firebase/auth';
import firestore from '@react-native-firebase/firestore';
import messaging from '@react-native-firebase/messaging';

// Re-export them directly
export {auth, firestore, messaging};

// Check if Firebase is initialized
let firebaseInitialized = false;
try {
  const authInstance = auth();
  if (authInstance) {
    firebaseInitialized = true;
  }
} catch (error: any) {
  console.warn('Firebase not initialized. Please configure google-services.json (Android) and GoogleService-Info.plist (iOS)');
  firebaseInitialized = false;
}

export const getFirebaseInitialized = () => firebaseInitialized;

